export const SegmentConstant = 'Segment';
export const RefreshTokenTimeDifference = 15;
export const DAWA_MAX_LENGTH = 100;
